import AppError from '../errors/AppError';
import { ICarrier } from '../interfaces/ICarrier';
import { IPaginationReturn } from '../interfaces/IPaginationReturn';

import { useRequest } from './useRequest';

const useCarriersService = () => {
  const request = useRequest<ICarrier>();
  const path = 'carriers';

  const listDynamically = async (queryParams: string): Promise<IPaginationReturn<ICarrier[]>> => {
    return await request
      .getManyPaginated({ path: `${path}/dynamically?${queryParams}`, sendAuthorization: true })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message, error.status);
      });
  };

  return { listDynamically };
};

export { useCarriersService };
